import { PointsFeatureCollection } from '@lidea/shared/util/types';
import classNames from 'classnames';
import { Marker, MarkerEvent } from 'react-map-gl';

import styles from './points-markers.module.css';

const isTest =
  typeof process !== 'undefined'
    ? process.env['NEXT_PUBLIC_CYPRESS'] === 'true'
    : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - import is used by vite
      import.meta.env.VITE_CYPRESS === 'true';

const PENDING_SYNC_COLOR = '#0000FF';

/* eslint-disable-next-line */
export interface PointsMarkersProps {
  points: PointsFeatureCollection;
  pendingSyncPointIds?: number[];
  syncingPointIds?: number[];
  mobile?: boolean;
  onPointClick: (id: number) => void;
  selectedPointId?: number;
}

export function PointsMarkers(props: PointsMarkersProps) {
  const handleMarkerClick = (e: MarkerEvent<MouseEvent>, pointId: number) => {
    e.originalEvent.stopPropagation();
    props.onPointClick(pointId);
  };

  const useMapClickTarget = props.mobile && !isTest;

  return (
    <>
      {props.points.features.map((point) => {
        const isPendingSync = props.pendingSyncPointIds?.includes(point.id);
        const isSyncing = props.syncingPointIds?.includes(point.id);

        return (
          <Marker
            key={point.id}
            anchor="center"
            latitude={point.geometry.coordinates[1]}
            longitude={point.geometry.coordinates[0]}
            onClick={
              useMapClickTarget
                ? undefined
                : (e) => handleMarkerClick(e, point.id)
            }
          >
            <button
              type="button"
              aria-label={`point ${point.properties.zone}`}
              className={classNames(styles['hitbox'], 'marker', {
                [styles['hitbox--mobile']]: useMapClickTarget,
              })}
              onClick={
                useMapClickTarget
                  ? undefined
                  : (e) => {
                      e.stopPropagation();
                      props.onPointClick(point.id);
                    }
              }
            >
              <span
                aria-hidden
                className={classNames(styles['dot'], {
                  [styles['dot--selected']]:
                    props.selectedPointId === point.id,
                  [styles['dot--syncing']]: isSyncing,
                })}
                style={{
                  backgroundColor: isPendingSync
                    ? PENDING_SYNC_COLOR
                    : point.properties.status,
                }}
              >
                {point.properties.zone}
              </span>
            </button>
          </Marker>
        );
      })}
    </>
  );
}

export default PointsMarkers;
